module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Key":"Eindeutige Kennung","Name":"Name","Properties":"Attribute","Add property":"Attribut hinzufügen"}}')
  delete Component.options._Ctor
}
